import { render } from "./OurStoresView.vue?vue&type=template&id=5bd1ff8c"
import script from "./OurStoresView.vue?vue&type=script&lang=js"
export * from "./OurStoresView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__